import React from "react";
import { useObserver } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";
import { SubcontractorInvoiceFragment } from "@graphql";
import { Body, Spinner, WithTooltip } from "@components";
import { makeStyles } from "@material-ui/core/styles";
import { SubcontractorInvoiceCard } from "./SubcontractorInvoiceCard";
import { Form, Text } from "@components/formx";
import { InvoiceSubcontractorDialogFormData } from "./utils";
import { FormStore } from "@modules/formx";

type Props = {
  form: FormStore<InvoiceSubcontractorDialogFormData>;
  canSubmit: boolean;
  loading: boolean;
  currentInvoice: SubcontractorInvoiceFragment;
  isInvoiceFound: boolean;
  onClose: () => void;
};

export function BookingSubcontractorInvoiceDialog(props: Props) {
  const { form, loading, currentInvoice, isInvoiceFound } = props;

  const classes = useStyles({});

  return useObserver(() => (
    <Dialog open onBackdropClick={props.onClose} classes={{ paper: classes.root }}>
      <DialogTitle>{locale.AddInvoiceNumber}</DialogTitle>

      <DialogContent>
        <Form store={form} allowUpdates>
          {loading && (
            <div className={classes.loading}>
              <Spinner size={16} />
            </div>
          )}

          <div className={classes.formRow}>
            <Text
              name={"invoiceNumber"}
              label={locale.PaymentNumber}
              TextFieldProps={{
                autoFocus: true,
                inputProps: {
                  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      form.submit(e);
                    }
                  }
                }
              }}
              onChange={(e) => {
                if (typeof e.target.value === "string") {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }
              }}
            />
          </div>

          {currentInvoice && (
            <WithTooltip title={locale.ClickForDetails}>
              <div className={classes.success} onClick={form.submit}>
                <SubcontractorInvoiceCard data={currentInvoice} />
              </div>
            </WithTooltip>
          )}

          <div>
            {!isInvoiceFound && (
              <Body className={classes.error} color="error">
                {locale.NothingFound}
              </Body>
            )}
          </div>
        </Form>
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={props.onClose}>
          {locale.Cancel}
        </Button>
      </DialogActions>
    </Dialog>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    width: "30rem"
  },

  loading: {
    padding: 8
  },

  success: {
    cursor: "pointer",
    padding: 8,
    border: `1px solid ${theme.palette.grey[400]}`,
    marginTop: 16,
    borderRadius: 4,
    transition: theme.transitions.create("background-color"),

    "&:hover": {
      backgroundColor: theme.palette.grey[200]
    }
  },

  error: {
    marginTop: 16,
    textAlign: "center"
  },

  customBtns: {
    ...theme.mixins.childrenMarginRight(4),
    display: "flex",
    flexWrap: "wrap",
    // justifyContent: "",
    marginTop: 16
  },

  formRow: {
    marginBottom: 8
  }
}));
